@if (!useSummaryView) {
    <div [class.hidden]="hidden" animate.enter="fade-in" class="flex flex-col w-full justify-between">
        <div class="flex flex-row items-center w-full">
            <mat-form-field class="w-full" [subscriptSizing]="subscriptSizing">
                @if (label) {
                    <mat-label [class]="labelClass">{{ label }}</mat-label>
                }
                <input matInput class="lowercase" type="text" [formControl]="controlOriginal" [readonly]="readonly" [required]="required" (blur)="onBlur.emit()">
                @if (controlOriginal.hasError('pattern') && !readonly && !hideHints) {
                    <mat-error>
                        {{ 'errorInFormat' | transloco }}
                    </mat-error>
                } @else if (controlOriginal.hasError('required') && !readonly && !hideHints) {
                    <mat-error>
                        {{ 'errorRequiredField' | transloco }}
                    </mat-error>
                } @else if (hint && !readonly && !hideHints) {
                    <mat-hint>{{ hint }}</mat-hint>
                }
            </mat-form-field>
        </div>
    </div>
} @else {
    {{ defaultValue }}
}